import {createSelector} from '@ngrx/store';

import {FILE_SYSTEMS_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';

export const selectFileSystemsState = createSelector(
  selectMasterDataModuleState,
  (moduleState) => moduleState[FILE_SYSTEMS_FEATURE_KEY]
);

export const selectFileSystemsEntities = createSelector(
  selectFileSystemsState,
  (state) => state.entities
);

export const selectFileSystems = createSelector(
  selectFileSystemsEntities,
  (entities) => Object.values(entities)
);

export const selectErrors = createSelector(
  selectFileSystemsState,
  (state) => state.errors
);

export const isLoading = createSelector(
  selectFileSystemsState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectFileSystemsState,
  (state) => state.loaded
);
